export const allTiers = ["Classic", "Emerald", "Amber", "Diamond", "Turquoise", "Yuhaaviatam"];
